import React, { useState, useEffect } from "react";
import {
    IonRadioGroup,
    IonRadio,
    IonItem,
    IonLabel,
} from "@ionic/react";

// Define question types
type QuestionType = "identifyOddOneOut" | "trueFalse" | "fillInTheBlanks" | "multipleChoice";

interface PictureQuestion {
    question: string;
    options: { src: string; answer: boolean }[];
}

interface IdentifyOddOneOutQuestion {
    question: string;
    options: string[];
    correct: string;
}

interface MultipleChoiceQuestion {
    question: string;
    options: string[];
    correct: string;
}

interface TrueFalseQuestion {
    question: string;
    correct: boolean;
}

interface FillInTheBlanksQuestion {
    question: string;
    correct: string;
    options: string[];
}


const TheEarth: React.FC = () => {
    const [currentQuestion, setCurrentQuestion] = useState<IdentifyOddOneOutQuestion | MultipleChoiceQuestion | TrueFalseQuestion | FillInTheBlanksQuestion | null>(null);
    const [selectedOption, setSelectedOption] = useState<string | boolean | null>(null);
    const [showResult, setShowResult] = useState<boolean>(false);
    const [isCorrect, setIsCorrect] = useState(false);
    const [showImage, setShowImage] = useState(false);

    const [questionBank, setQuestionBank] = useState<Record<QuestionType, (IdentifyOddOneOutQuestion | MultipleChoiceQuestion | TrueFalseQuestion | FillInTheBlanksQuestion)[]>>({
        //picture: [],
        identifyOddOneOut: [],
        multipleChoice: [],
        trueFalse: [],
        fillInTheBlanks: []
    });

    const fetchQuestions = async () => {
        try {
            let multipleChoiceQuestion: MultipleChoiceQuestion[] = [];
            let trueFalseQuestion: TrueFalseQuestion[] = [];
            let identifyOddOneOutQuestion: IdentifyOddOneOutQuestion[] = [];
            let fillInTheBlanksQuestion: FillInTheBlanksQuestion[] = [];

            if (process.env.REACT_APP_DEVELOPMENT !== 'WEB') {

                const response = await fetch(process.env.REACT_APP_API_URL + 'TheEarthClassTwoTrueFalse.json');
                trueFalseQuestion = await response.json();

                const response1 = await fetch(process.env.REACT_APP_API_URL + 'TheEarthClassTwoMultipleChoice.json');
                multipleChoiceQuestion = await response1.json();

                const response2 = await fetch(process.env.REACT_APP_API_URL + 'TheEarthClassTwoIdentifyOddOneOut.json');
                identifyOddOneOutQuestion = await response2.json();

                const response3 = await fetch(process.env.REACT_APP_API_URL + 'TheEarthClassTwoFillInTheBlanks.json');
                fillInTheBlanksQuestion = await response3.json();

            } else {
                const module = await import('../../../datas/TheEarthClassTwoTrueFalse.json');
                trueFalseQuestion = module.default;

                const module1 = await import('../../../datas/TheEarthClassTwoMultipleChoice.json');
                multipleChoiceQuestion = module1.default;

                const module2 = await import('../../../datas/TheEarthClassTwoIdentifyOddOneOut.json');
                identifyOddOneOutQuestion = module2.default;

                const module3 = await import('../../../datas/TheEarthClassTwoFillInTheBlanks.json');
                fillInTheBlanksQuestion = module3.default;
            }
            setQuestionBank({
                //picture: pictureQuestionQuestion,
                identifyOddOneOut: identifyOddOneOutQuestion,
                multipleChoice: multipleChoiceQuestion,
                trueFalse: trueFalseQuestion,
                fillInTheBlanks: fillInTheBlanksQuestion,
            });
        } catch (error) {
            console.error("Error loading questions:", error);
        }
    };

    useEffect(() => {
        fetchQuestions();
        document.title = "Mamas Guidance - Class Two - Environment Science - The Earth"; // Set page title
    }, []);

    useEffect(() => {
        if (questionBank.identifyOddOneOut.length || questionBank.multipleChoice.length || questionBank.trueFalse.length || questionBank.fillInTheBlanks.length) {
            getRandomQuestion();
        }
    }, [questionBank]);

    const getRandomQuestion = () => {
        const questionTypes = Object.keys(questionBank) as QuestionType[];
        const randomType = questionTypes[Math.floor(Math.random() * questionTypes.length)];
        const randomQuestion = questionBank[randomType][Math.floor(Math.random() * questionBank[randomType].length)];
        setCurrentQuestion(randomQuestion);
        setSelectedOption(null);
    };

    const handleAnswerSubmit = (option: any) => {
        setSelectedOption(option);
        if (!currentQuestion) return;

        if ("correct" in currentQuestion) {
            if (option === currentQuestion.correct) {
                showNextQuestion();
                setIsCorrect(true);
            }
        } else if ("options" in currentQuestion) {
            // For picture-based questions
            if ((currentQuestion as PictureQuestion).options.find((opt) => opt.src === option)?.answer) {
                showNextQuestion();
                setIsCorrect(true);
            }
        }
    };

    const showNextQuestion = () => {
        setShowImage(true);
        setTimeout(() => {
            setShowImage(false);
            setSelectedOption(null);
            getRandomQuestion();
            setIsCorrect(false)
        }, 5000);
    }

    return (
        <>
            {showImage === false ? (
                <>
                    <div className="contentPart showCenter fillPreposition additionWord">
                        {currentQuestion ? (
                            <>
                                <h3 className="mb-2">{currentQuestion.question}</h3>

                                {"options" in currentQuestion ? (
                                    // Handle multiple-choice or identify odd one out question
                                    typeof currentQuestion.options[0] != "object" ? (
                                        <IonRadioGroup onIonChange={(e) => handleAnswerSubmit(e.detail.value)}>
                                            {(currentQuestion as IdentifyOddOneOutQuestion | MultipleChoiceQuestion).options.map((option, index) => (
                                                <IonItem
                                                    className={`grid-item ${selectedOption === option
                                                        ? isCorrect === true
                                                            ? "correct"
                                                            : "errorItems"
                                                        : ""
                                                        }`}
                                                    key={index}>
                                                    <IonRadio slot="start" value={option} />
                                                    <IonLabel>{option}</IonLabel>
                                                </IonItem>
                                            ))}
                                        </IonRadioGroup>
                                    ) : (
                                            // Handle picture question
                                            <></>
                                        // <div className="row">
                                        //     {(currentQuestion as PictureQuestion).options.map((option, index) => (
                                        //         <div
                                        //             className={`col-12 col-md-3 mb-5 `}
                                        //             key={index}>
                                        //             <img
                                        //                 src={process.env.REACT_APP_API_URL + option.src}
                                        //                 onClick={() => handleAnswerSubmit(option.src)}
                                        //                 className={`img-thumbnail ${selectedOption === option.src
                                        //                     ? isCorrect === true
                                        //                         ? "correct"
                                        //                         : "errorImgItems"
                                        //                     : ""
                                        //                     }`}
                                        //                 style={{
                                        //                     cursor: "pointer",
                                        //                     height: '150px',
                                        //                     width: '150px'
                                        //                 }}
                                        //             />
                                        //         </div>
                                        //     ))}
                                        // </div>
                                    )
                                ) :
                                    <>
                                        <IonRadioGroup onIonChange={(e) => handleAnswerSubmit(e.detail.value!)}>
                                            <IonItem
                                                className={`grid-item ${selectedOption === true
                                                    ? isCorrect === true
                                                        ? "correct"
                                                        : "errorItems"
                                                    : ""
                                                    }`}>
                                                <IonRadio slot="start" value={true} />
                                                <IonLabel>True</IonLabel>
                                            </IonItem>
                                            <IonItem
                                                className={`grid-item ${selectedOption === false
                                                    ? isCorrect === true
                                                        ? "correct"
                                                        : "errorItems"
                                                    : ""
                                                    }`}>
                                                <IonRadio slot="start" value={false} />
                                                <IonLabel>False</IonLabel>
                                            </IonItem>
                                        </IonRadioGroup>
                                    </>
                                }
                            </>
                        ) : (
                            <p>Loading question...</p>
                        )}
                    </div>
                </>
            ) : (
                <>
                    <div className="contentPart showMiddle">
                        <img
                            style={{ height: "150px" }}
                            className="img-fluid"
                            src={process.env.REACT_APP_WELDONE_LINK}
                        />
                    </div>
                </>
            )}
        </>
    );
};

export default TheEarth;